import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../domain';
import {FlashcardsView} from './flashcard/crud/FlashcardsView';
import {GapFillingView} from './gap-filling/crud/GapFillingView';
import {GrexView} from './grouping-exercise/crud/GrexView';
import {X9MatchingQuestionView} from './matching-question/crud/X9MatchingQuestionView';
import {X9McqView} from './mcq/crud/X9McqView';
import {OpenEndedQuestionInlineView} from './open-ended-question-inline/crud/OpenEndedQuestionInlineView';
import {OpenEndedQuestionView} from './open-ended-question/crud/OpenEndedQuestionView';
import {SelectQuestionView} from './select-question/crud/SelectQuestionView';
import {SlideShowView} from './slideshow/crud/SlideShowView';
import {X9StaticHtmlView} from './static-html/X9StaticHtmlView';
import {X9StaticImageView} from './static-image/X9StaticImageView';
import {X9SyncedAudioView} from './synced-audio/crud/X9SyncedAudioView';
import {X9SyncedVideoView} from './synced-video/crud/X9SyncedVideoView';

interface Props {
  x9: X9Content | X9ContentSnapshot
}

export class X9ViewComponent extends React.Component<Props> {
  render() {
    const x9 = this.props.x9;

    switch (x9.ContentType) {
      case 'static-html':
        return (<X9StaticHtmlView x9={x9}/>);
      case 'static-image':
        return (<X9StaticImageView x9={x9}/>);
      case 'matching-question':
        return (<X9MatchingQuestionView x9={x9}/>);
      case 'select-question':
        return (<SelectQuestionView x9={x9}/>);
      case 'gap-filling':
        return (<GapFillingView x9={x9}/>);
      case 'multiple-choice-question':
        return (<X9McqView x9={x9}/>);
      case 'grouping-exercise':
        return (<GrexView x9={x9}/>);
      case 'flashcards':
        return (<FlashcardsView x9={x9}/>);
      case 'slideshow':
        return (<SlideShowView x9={x9}/>);
      case 'open-ended-question':
        return (<OpenEndedQuestionView x9={x9}/>);
      case 'open-ended-question-inline':
        return (<OpenEndedQuestionInlineView x9={x9}/>);
      case 'synced-audio':
        return (<X9SyncedAudioView x9={x9}/>);
      case 'synced-video':
        return (<X9SyncedVideoView x9={x9}/>);
    }

    return (
      <div className="alert alert-danger">
        I don't know how to handle content type {x9.ContentType}
      </div>
    );
  }
}
